import { useContext } from "react";
import { HeaderColorContext } from "./HeaderColorContext";

export const useHeaderColor = () => useContext(HeaderColorContext);
